import * as tomSelect from "/Assets/libs/TomSelect/tom-select.complete.js";

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-prb-combobox]").forEach(element => {
        new ResourcesByProductBlock(element);
    });
});

class ResourcesByProductBlock {
    constructor(element) {
        this.element = element;
        this.initializeCombobox();
    }

    initializeCombobox() {
        const self = this;

        new tomSelect(self.element, {
            onChange: function (value) {
                const selectedOption = self.element.querySelector("option[value='" + value + "']");
                const redirectLink = selectedOption.getAttribute("redirect-link-href");

                if (redirectLink != "") {
                    window.location.href = redirectLink;
                }
            }
        });
    }
}